/**
 * Settings module translations - Empty States section
 */

const emptyStates = {
  noDataAvailable: "No hay datos disponibles",
  refresh: "Actualizar",
  noCountriesAdded: "No se han agregado países"
};

export default emptyStates;
